import * as Yup from "yup";

export default Yup.object().shape({
  name: Yup.string().required("Field is required"),
  address: Yup.string().required("Field is required"),
  units: Yup.array(Yup.string()).min(1).required("Field is required"),
});
